import styled, { css } from 'styled-components';
import { variables } from 'components/theme';
import { tabsTextColor, bodyBackgroundColor } from 'utils/theme';

export const NotFoundWrapper = styled.div`
  ${variables.fonts.openSansSemiBold};
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 730px;
  width: 100%;
  padding-left: 160px;
  line-height: 1.1;
  color: ${tabsTextColor};

  h1 {
    font-size: 65px;
    margin-top: 21px;
  }

  h3 {
    ${variables.fonts.openSansRegular}
    margin-bottom: 21px;
    text-transform: uppercase;
  }

  a {
    display: inline-block;
    ${variables.fonts.openSansBold}
    text-decoration: none;
  }

  @media only screen and (max-width: 767px) {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 110px;
    text-align: center;
  }
`;

export const NotFound404 = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  width: 140px;
  height: 140px;
  background-size: cover;

  ${({ image }) =>
    image &&
    css`
      background-image: url(${image});
    `}

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    transform: scale(2.4);
    border-radius: 50%;
    background-color: ${bodyBackgroundColor};
    z-index: -1;
  }

  @media only screen and (max-width: 767px) {
    width: 110px;
    // height: 110px;
    left: 35%;

    &::before {
      left: 0%;
    }
  }
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  text-decoration: underline;
  color: #1155cc;
  padding: 0;
`;
